export const CursorConfig = Object.freeze({
	magneticRadius: 10,

	pullStrength: 0.35,
	pullStiffness: 0.1,
	pullDamping: 0.7,

	releaseStiffness: 0.08,
	releaseDamping: 0.55,
});
